import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { DEFAULT_USER, IS_DEMO } from 'config.js';
import { messages } from 'lang/messages/messages';
import { actions } from 'react-table';

const initialState = {
    classificationList: {},
    classficationNotification: {},
    PublisherDashboard: {},
};

const ClassificationSlice = createSlice({
    name: 'classifications',
    initialState,
    reducers: {
        setClassification(state, action) {
            state.classificationList = action.payload;
        },
        setToast(state, action) {
            state.classficationNotification = action.payload;
        },
        setPublisherDashBoard(state, action) {
            state.PublisherDashboard = action.payload;
        }

    },
});

export const ClassificationListAPi = (tokendata, page, limit, search) => async (dispatch) => {

    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/journalClassificationList?page=${page}&limit=${limit}&search=${search}`,
        {
            headers: {
                "authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "fsdfff")
            dispatch(setClassification(res?.data))


        })
        .catch((err) => {
            console.log(err?.response, "wddss");

        })

}
export const PublisherDashBoardAPi = (tokendata) => async (dispatch) => {

    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/publisher/dashboard`,
        {
            headers: {
                "authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "fsdfff")
            dispatch(setPublisherDashBoard(res?.data))


        })
        .catch((err) => {
            console.log(err?.response, "wddss");

        })

}
export const ClassificationPostApi = (values, tokendata) => async (dispatch) => {

    const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/ats/journalClassificationAdd`, values, {
        headers: {
            "authorization": ` Bearer ${tokendata}`
        }
    })
        .then((res) => {
            console.log(res, "ssddss");
            //   dispatch(setListRigistor(res?.data?.data));
            dispatch(setToast({
                status: true, message: res?.data?.message
            }))
        })
        .catch((err) => {
            console.log(err?.response, "errror");
            dispatch(setToast({
                status: false, message: err?.response?.data?.message
            }))
        })
}

export const ClassificationEditApi = (payload, tokendata, uuid) => async (dispatch) => {
    const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/ats/journalClassificationUpdate/${uuid}`, payload, {
        headers: {
            "Authorization": `Bearer ${tokendata}`
        }
    })
        .then((res) => {
            console.log(res, "kfksk");
            //   dispatch(setEditorList(res?.data?.data))
            dispatch(setToast({
                status: true, message: res?.data?.message
            }))
        })
        .catch((err) => {
            console.log(err?.response, "error");
            dispatch(setToast({
                status: false, message: err?.response?.data?.message
            }))
        })
}


export const ClassificationDeleteApi = (deleteuuid, tokendata) => async (dispatch) => {
    const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}/ats/journalClassificationDelete/${deleteuuid}`,
        {
            headers: {
                "Authorization": `Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "lkkdelete");
            // dispatch(setDeleteItem(res.data))
            dispatch(setToast({
                status: true, message: res?.data?.message
            }))
        })
        .catch((err) => {
            console.log(err?.response, "errresf888");
            dispatch(setToast({
                status: false, message: err?.response?.data?.message
            }))

        })
}



export const { setClassification, setToast, setPublisherDashBoard } = ClassificationSlice.actions;
const ClassificationReducer = ClassificationSlice.reducer;

export default ClassificationReducer;
